import { workBenchStatus } from "../../modules/vscDashboard/constants";
import StatusPillStyles from "./StatusPillBu.module.scss";
import Tooltip from "../Tooltip/Tooltip"; // Assuming you have a Tooltip component
import GeminiIcon from "../../assets/GeminiAI.svg"; // Assuming you have an info icon

export const StatusPillBU = ({ status }: any) => {
  const getStyle = () => {
    // Normalize status to lowercase and replace spaces with underscores for comparison
    const normalizedStatus = (status || "").toString().toLowerCase().replaceAll(/\s+/g, '_');
    
    switch (normalizedStatus) {
      case workBenchStatus.DRAFT:
        return { text: "Draft", style: StatusPillStyles.draft };
      case workBenchStatus.ASSIGNING_CATEGORY_MANAGER:
        return { text: "Assigning Category Manager", style: StatusPillStyles.reviewing };
      case workBenchStatus.SUBMITTED_FOR_APPROVAL:
        return { text: "Submitted For Approval", style: StatusPillStyles.submittedForApproval };
      case workBenchStatus.META_EXTRACTION_IN_PROGRESS:
        return {
          text: "Reviewing", // Or "Reviewing" if that's preferred text
          style: StatusPillStyles.reviewing, // Or a specific style for meta extraction
          isDelayedReview: false, // Flag for the special message
        };
      default:
        return {
          text: status || "N/A", // Show the actual status text from API
          style: StatusPillStyles.reviewing,
        };
    }
  };

  const { text, style, isDelayedReview } = getStyle();
  const delayedMessage = "Approval is taking more time than usual. Recommended to connect with Category manager.";


  return (
    <div className={StatusPillStyles.statusCellWrapper}>
      <span className={style}>{text}</span>
      {isDelayedReview && (
        <div className={StatusPillStyles.delayedMessageRow}>
          <img src={GeminiIcon} alt="info" className={StatusPillStyles.delayedInfoIcon} />
          <span>{delayedMessage}</span>
        </div>
      )}
    </div>
  );
};